<template>
    <div class="webhook-data-item">
        <CustomPicker
            v-model="clone.field"
            :items="properties"
            idKey="id"
            labelKey="label"
            :title="$t('message.selectField')"
            style="width: 250px"
        />
        <TiptapEditor placeholder="Value" :show-attributes="true" v-model="clone.value" automation-mode />
        <SupsisButton small danger @click="deleteItem" v-if="isDeleteButtonVisible"
            ><i class="material-icons">delete</i>
        </SupsisButton>
    </div>
</template>
<script>
import Vue from "vue";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import _ from "lodash";

export default Vue.extend({
    name: "UpdateInfo",
    components: { SupsisButton, TiptapEditor, CustomPicker },
    props: ["payload", "properties", "isDeleteButtonVisible", "type"],
    data() {
        const clone = _.cloneDeep(this.payload) || {
            field: null,
            value: null,
        };
        return {
            clone,
        };
    },
    mounted() {
        console.log("UpdateContactVisitor mounted", this.clone);
    },
    methods: {
        deleteItem() {
            this.$emit("delete");
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                console.log("UpdateContactVisitor watch..", newValue);
                this.$emit("save", newValue);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.webhook-data-item {
    display: flex;
    flex-direction: row;
    gap: 10px;
}
</style>
